import React from 'react';
import { Alert as MuiAlert, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

const Alert = ({ variant = 'error', message, onClose }) => {
  if (!message) return null;

  const severity = variant === 'danger' ? 'error' : variant;

  return (
    <MuiAlert 
      severity={severity} 
      action={
        onClose && (
          <IconButton size="small" onClick={onClose}>
            <Close fontSize="small" />
          </IconButton>
        )
      }
      sx={{ mb: 2 }}
    >
      {message}
    </MuiAlert>
  );
};

export default Alert;
